var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBloodGlucosenew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FFF3F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5807_28250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 16.0995L20.05 21.0495C19.0711 22.0285 18.4045 23.2758 18.1345 24.6336C17.8644 25.9915 18.0031 27.3989 18.5329 28.6779C19.0628 29.957 19.96 31.0502 21.1111 31.8193C22.2622 32.5885 23.6156 32.999 25 32.999C26.3844 32.999 27.7378 32.5885 28.8889 31.8193C30.04 31.0502 30.9373 29.957 31.4671 28.6779C31.9969 27.3989 32.1356 25.9915 31.8656 24.6336C31.5955 23.2758 30.9289 22.0285 29.95 21.0495L25 16.0995ZM25 13.2715L31.364 19.6355C32.6227 20.8942 33.4798 22.4978 33.8271 24.2436C34.1743 25.9895 33.9961 27.7991 33.3149 29.4436C32.6337 31.0881 31.4802 32.4937 30.0001 33.4826C28.5201 34.4716 26.78 34.9994 25 34.9994C23.22 34.9994 21.4799 34.4716 19.9999 33.4826C18.5198 32.4937 17.3663 31.0881 16.6851 29.4436C16.0039 27.7991 15.8257 25.9895 16.1729 24.2436C16.5202 22.4978 17.3773 20.8942 18.636 19.6355L25 13.2715Z",
    fill: "#962A51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5807_28250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodGlucosenew);
export default __webpack_public_path__ + "static/media/Blood Glucosenew.db1d2621b0e5414edca72c1dc6970463.svg";
export { ForwardRef as ReactComponent };